<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#D5F5E3">
        <v-card-title>
          <v-icon large left>mdi-text-box</v-icon>
          <h6>Gestión - Listado de Ordenes de Trabajo</h6>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="6" sm="6" md="6">
              <v-text-field label="N° de OT" dense v-model="filtronumot">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field label="Detalle de OT" dense v-model="filtrodetalle">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Fecha de Confección: Desde" dense v-model="filtrofechaconfd">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Fecha de Confección: Hasta" dense v-model="filtrofechaconfh">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Fecha de Cierre: Desde" dense v-model="filtrofechacierred">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Fecha de Cierre: Hasta" dense v-model="filtrofechacierreh">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Año" dense v-model="filtroanio">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Carpeta" dense v-model="filtrocarpeta">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-select v-model="filtrotipoot" :items="itemstipo" label="Tipo de OT:" item-text="nombre"
                item-value="codigo" outlined dense></v-select>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-select v-model="filtroestado" :items="itemsopcion" label="Estado:" item-text="nombre"
                item-value="codigo" outlined dense></v-select>
            </v-col>
          </v-row>
          <v-row align="center" justify="space-around">
            <v-btn tile color="success" @click="cargarListado()">
              <v-icon left> mdi-magnify </v-icon>
              Buscar
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
      <v-data-table dense :headers="headers" height="400" fixed-header :items="listadoot" locale="es-ar"
        class="elevation-1" :items-per-page="100" :footer-props="{
          itemsPerPageText: 'OTs por página',
        }" :loading="loadtable" loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">

      </v-data-table>

    </v-app>
  </div>
</template>

<script>
import axios from "../../../src/axios-auth";

export default {
  data: (vm) => ({

    filtronumot: "",
    filtrodetalle: "",
    filtrofechaconfd: "",
    filtrofechaconfh: "",
    filtrofechacierred: "",
    filtrofechacierreh: "",
    filtroanio: "",
    filtrocarpeta: "",
    filtrotipoot: "",
    filtroestado: "T",
    listadoot: [],
    itemstipo: [
      { nombre: "TODOS", codigo: "" },
      { nombre: "ANUAL", codigo: "1" },
      { nombre: "APOYATURA", codigo: "2" },
      { nombre: "CLIENTE", codigo: "3" },
      { nombre: "DESARROLLO", codigo: "4" },
      { nombre: "INTERNA", codigo: "5" },
      { nombre: "STOCk", codigo: "6" },
      { nombre: "SPV", codigo: "7" },
    ],
    itemsopcion: [
      { nombre: "TODAS", codigo: "T" },
      { nombre: "ABIERTAS", codigo: "P" },
      { nombre: "CERRADAS", codigo: "C" },
    ],
    loadtable: false,
    headers: [
      {
        text: 'N° OT',
        align: 'start',
        sortable: false,
        value: 'otrabajo',
      },
      { text: 'Detalle de OT', value: 'detalle' },
      { text: 'Inicio', value: 'fecconf', sortable: false },
      { text: 'Cierre', value: 'feccierre', sortable: false },
      { text: 'Cliente', value: 'cliente', sortable: false },
      { text: 'Obra', value: 'Obra', sortable: false },
      { text: 'Carpeta', value: 'carpeta', sortable: false },
      { text: 'Tipo de OT', value: 'nombretipo', sortable: false },
      { text: 'Nota', value: 'nota1', sortable: false },
    ],
  }),

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    limpiar() {
      this.listadoot = []
    },
    cargarListado() {
      this.loadtable = true;
      const numot = this.filtronumot
      const detalle = this.filtrodetalle
      const fechaconfd = this.filtrofechaconfd
      const fechaconfh = this.filtrofechaconfh
      const fechacierred = this.filtrofechacierred
      const fechacierreh = this.filtrofechacierreh
      const carpeta = this.filtrocarpeta
      const ano = this.filtroanio
      const tipo = this.filtrotipoot
      const estado = this.filtroestado
      let self = this;
      axios
        .get("/Gestion/ListadoOt?", {
          params: {
            numot: numot,
            detalle: detalle,
            fecconfd: fechaconfd,
            fecconfh: fechaconfh,
            feccierred: fechacierred,
            feccierreh: fechacierreh,
            carpeta: carpeta,
            ano: ano,
            tipo: tipo,
            estado: estado,

          }
        })
        .then(response => {
          self.listadoot = response.data;
          self.loadtable = false;
        })
        .catch(error => {
          self.listadoot = [];
          console.log(error);
        });

    },

  },
};
</script>